import { api } from 'shared/api'

import { GoogleSheetSchemas } from './schemas'

export const googleSheetApi = {
  getSpreadsheets: api.account.createGet({
    url: '/integration/googleSheets/getSpreadsheets',
    schemas: GoogleSheetSchemas.getLists,
  }),
  getWorksheets: api.account.createGet({
    url: '/integration/googleSheets/getSheets',
    schemas: GoogleSheetSchemas.getWorksheets,
  }),
  getColumnHeaders: api.account.createGet({
    url: '/integration/googleSheets/getColumnHeaders',
    schemas: GoogleSheetSchemas.getColumnHeaders,
  }),
}
